import React, { useContext, useEffect, useRef, useState } from "react";
import $ from "jquery";

import { useTranslation } from "react-i18next";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import jwtInterceoptor from "../../components/shared/jwtInterceptor";

import moment from "moment";

import Swal from "sweetalert2";

import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import OrgContext from "../../organisation/OrgContext";
import { API } from "../../services/api";
import { useNavigate } from "react-router-dom";

import { frFR, enUS } from "@mui/x-data-grid";
import { LinearProgress } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import { formatNumber } from "../../helpers/formater";
import useAuthHelper from "../../helpers/AuthHelper";
import Papa from "papaparse";
import logo from "../../assets/images/ElmanagerLogo.png";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          x
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

function FactureAvoirList(props) {
  const [t, i18n] = useTranslation();

  const { organisation } = useContext(OrgContext);

  const [invoices, setInvoices] = useState([]);

  const [status, setSatus] = useState([]);

  const [currentSelectedStatus, setCurrentSelectedStatus] = useState(0);
  let [newStatus, setNewStatus] = useState(0);
  const [currentSelectedInvoice, setCurrentSelectedInvoice] = useState(0);
  const navigate = useNavigate();

  const [grandTotal, setGrandTotal] = useState(null);
  const [selectedRow, setSelectedRow] = useState();
  const [loadingData, setLoadingData] = useState(false);
  // visible columns
  const [visibleColumns, setVisibleColumns] = useState({
    __check__: true,
    "Numéro de facture": true,
    Client: true,
    "Date de Facture": true,
    "Date d'échéance": true,
    Montant: true,
    action: true,
  });
  //store the visible columns
  const { onlyCommercial, hadDeleteAccess, hadEditAccess } = useAuthHelper();

  useEffect(() => {
    onlyCommercial();

    const storedColumns = JSON.parse(
      localStorage.getItem("visibleColumnsAvoire")
    );
    if (storedColumns) {
      setVisibleColumns(storedColumns);
    }
  }, []);
  useEffect(() => {
    localStorage.setItem(
      "visibleColumnsAvoire",
      JSON.stringify(visibleColumns)
    );
  }, [visibleColumns]);

  const handleColumnVisibilityModelChange = (newModel) => {
    if (Object.keys(newModel).length === 0) {
      newModel = {
        __check__: true,
        "Numéro de facture": true,
        Client: true,
        "Date de Facture": true,
        "Date d'échéance": true,
        Montant: true,
        action: true,
      };
    }
    if (newModel) {
      console.log(visibleColumns);
      const updatedVisibleColumns = { ...visibleColumns, ...newModel };

      setVisibleColumns(updatedVisibleColumns);
      console.log("visible colonne state: ", updatedVisibleColumns);
    } else {
      console.error("newModel is undefined");
    }
  };

  useEffect(() => {
    if (organisation.id) {
      fetchStatusInvoices();
      fetchInvoices();
    }
  }, []);

  const fetchInvoices = async () => {
    setLoadingData(true);
    const response = await jwtInterceoptor.get(
      `/data/user/factures_avoir/${organisation.id}`
    );

    if (response.status === 200) {
      setInvoices(response.data.data);
    }
    setLoadingData(false);
  };

  const fetchStatusInvoices = async () => {
    const response = await jwtInterceoptor.get(
      `/data/user/status/factures_avoir`
    );

    if (response.status === 200) {
      let invs = response.data.data.filter(
        (status) => status.id !== 2 && status.id !== 3
      );
      setSatus(invs);
    }
  };

  const deleteItem = async (inv) => {
    Swal.fire({
      title: t("Are you sure?"),
      text: t("You won't be able to revert this!"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: t("Yes, delete it!"),
      cancelButtonText: t("Cancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await jwtInterceoptor.delete(
          `/data/user/factures_avoir/delete/${inv.id}`
        );

        if (response.status === 200) {
          if (response.data.status == true) {
            let invs = invoices.filter((el) => el.id != inv.id);

            setInvoices(invs);

            Swal.fire(
              t("Deleted!"),
              t("Your record has been deleted."),
              "success"
            );

            return;
          }
        }

        Swal.fire({
          icon: "warning",
          title: "",
          text: t("Something went wrong!, try again"),
        });
      }
    });
  };

  const formatNumber = (number) => {
    let result = number.toString().padStart(6, "0");
    return result;
  };

  const columns = [
    {
      field: "Numéro de facture",
      headerName: t("Numéro de facture"),
      valueGetter: (params) => params.row?.invoice_number,
      width: 180,
    },
    /*{
            field: 'Référence de facture',
            headerName: t("Référence de facture"),
            valueGetter: (params) => params.row?.invoice_number,
            width: 180,
        },*/
    {
      flex: 1,
      field: "Numéro de pièce",
      headerName: t("Numéro de pièce"),
      valueGetter: (params) => `FAV${params.row?.id}`,
    },
    {
      flex: 1,
      field: "Facture de vente",
      headerName: t("Facture de vente"),
      valueGetter: (params) =>
        params.row?.facture_vente_id != 0
          ? `V${params.row?.facture_vente_id}`
          : "",
    },
    {
      flex: 1,
      field: "Client",
      headerName: t("Client"),
      valueGetter: (params) => params.row.client.companyName,
    },
    {
      flex: 1,
      field: "Date de Facture",
      headerName: t("Date de Facture"),
      valueGetter: (params) => params.row.created_at,
      valueFormatter: (params) => moment(params.value).format("DD/MM/YYYY"),
      type: "date",
    },
    {
      flex: 1,
      field: "Date d'échéance",
      headerName: t("Date d'échéance"),
      valueGetter: (params) =>
        `${moment(params.row.due_date).format("DD/MM/YYYY") || ""}`,
    },
    {
      flex: 1,
      field: "Montant",
      headerName: t("Montant"),
      valueGetter: (params) =>
        `${`${Number(params.row.total_ttc).toFixed(2)} ` || ""}`,
    },
    {
      field: "action",
      headerName: t("ACTIONS"),
      width: 220,
      sortable: false,
      disableClickEventBubbling: true,

      renderCell: (params) => {
        const onDelete = (e) => {
          if (!hadDeleteAccess()) {
            toast.error(
              t(
                "Vous n'avez pas les droits pour supprimer cette facture d'avoir."
              ),
              {
                position: "top-right",
                autoClose: 5000,
              }
            );
            return;
          }
          const inv = params.row;
          return deleteItem(inv);
        };

        const onEdit = (e) => {
          const inv = params.row;
        };

        /**
         * @param e
         */
        const emailInvoice = async (e) => {
          const inv = params.row;
          console.log(inv);
          const id = toast.loading(
            "Votre facture d'avoir est en cours d'envoi, veuillez ne pas fermer la fenêtre.",
            {
              position: "top-center",
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            }
          );

          const response = await jwtInterceoptor
            .post("data/facturesavoir/send", inv)
            .then((res) => {
              toast.update(id, {
                render: "Votre facture d'avoir a été envoyé avec succès.",
                type: "success",
                isLoading: false,
              });
            })
            .catch((error) => console.log(error));
        };

        const onPrint = (e) => {
          print(params.row);
        };

        const onDetails = (e) => {
          const inv = params.row;
          navigate(`/facture_avoir/details/${inv.id}`);
        };

        return (
          <div className="btn-list">
            <button
              onClick={onPrint}
              id="bPrint"
              type="button"
              className="btn  btn-sm btn-warning"
            >
              <span className="fe fe-save"> </span>
            </button>
            {/*<button onClick={onEdit} id="bEdit" type="button" className="btn  btn-sm btn-primary">
                            <span className="fe fe-edit"> </span>
                        </button>*/}
            <button
              onClick={onDelete}
              id="bDel"
              type="button"
              className="btn  btn-sm btn-danger"
              title={'Supprimer'}
            >
              <span className="fe fe-trash-2"> </span>
            </button>
            <button
              onClick={emailInvoice}
              id="bDel"
              type="button"
              className="btn  btn-sm btn-danger"
              title={'Envoyer par email'}
            >
              <span className="fe fe-mail"> </span>
            </button>
            <button
              onClick={onDetails}
              id="bEdit"
              type="button"
              className="btn  btn-sm btn-primary"
              title={'Voir les détails'}
            >
              <span class="fe fe-eye"> </span>
            </button>
          </div>
        );
      },
    },
  ];

  const print = async (data) => {
    // Vérifier si un modèle de facture est sélectionné
    if (!organisation?.invoice_model_id) { 
      Swal.fire({
        icon: "warning", 
        title: t("Attention"), 
        text: t("Aucun modèle de facture n'est actuellement sélectionné."), });
     return; }

    const response = await jwtInterceoptor.get(
      `/data/user/factures_avoir/generate/${data.id}`,
      { responseType: "arraybuffer" }
    );
    if (response.status === 200) {
      const type = response.headers["content-type"];
      const blob = new Blob([response.data], { type: type, encoding: "UTF-8" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = data.invoice_number + "FAV" + data.id;
      link.click();
    }
  };

  const handleStatusChange = (e) => {
    setNewStatus(e.target.value);
  };

  const editInvoiceStatus = async () => {
    let status = {};
    console.log("currentSelectedInvoice : ", currentSelectedInvoice);
    console.log("newStatus : ", newStatus);
    status = {
      id: currentSelectedInvoice,
      new_status: newStatus,
    };
    $("#exampleModal").hide();
    $(".modal-backdrop").css({
      "background-color": "transparent",
      display: "none",
    });
    const response = await jwtInterceoptor
      .post("/data/user/facturesavoir/status/", status)
      .then((res) => {
        console.log("has been edited: ", res.data.data);
        fetchInvoices();
        Swal.fire(t("Le status est modifier avec succés"), t(""), "success");
      })
      .catch((error) => console.log("error while save", error));
  };
  const downloadEtatFac = async () => {
    if (!selectedRow || selectedRow.length === 0) {
      console.warn("Aucune facture sélectionnée");
      return;
    }

    const getMoyenPaiement = (facture) => {
      if (facture.payment && facture.payment.length > 0) {
        const paiement = facture.payment[facture.payment.length - 1];

        if (paiement.banquePaymentOption) return "Banque";
        if (paiement.chequeId) return "Chèque";
        if (paiement.effetId) return "Effet";
        if (paiement.payment_account) return "Caisse";

        return "Autre";
      }
      return "N/A";
    };
    // calcule montants

    // Nouvelle structure qui affiche les produits sur des lignes distinctes
    const donneesFormatees = [];
    let totalQte = 0;
    let totalPrixHT = 0;
    let totalPaiement = 0;

    // Parcourir chaque facture
    selectedRow.forEach((facture) => {
      // Récupérer le montant réellement payé (payed_amount)
      // const montantPaye = facture.payed_amount
      //   ? Number(facture.payed_amount)
      //   : (facture.payment && facture.payment.length > 0 ? Number(facture.payment[facture.payment.length-1].payed_amount || 0) : 0);
      const montantPaye =
        facture.status == 2
          ? facture.total_ttc
          : facture.payment.reduce((acc, paiement) => {
              acc += Number(paiement.payed_amount);
              return acc;
            }, 0);
      // Ajouter au total des paiements seulement une fois par facture
      totalPaiement += montantPaye;
      console.log("montantPaye", montantPaye);
      // Si la facture a des produits (ce qui est toujours le cas d'après vos informations)
      if (facture.products && facture.products.length > 0) {
        // Pour chaque produit de la facture
        facture.products.forEach((item, index) => {
          // Calculer les totaux
          const qte = Number(item.qty || 0);
          const prixUnitHT = Number(item.price_unit_ht || 0);
          const prixHT = Number(item.total_ht || 0);

          totalQte += qte;
          totalPrixHT += prixHT;

          // Ajouter une ligne pour ce produit
          donneesFormatees.push({
            date_facture: facture.created_at?.split("T")[0] || "N/A",
            date_echeance: facture.due_date?.split("T")[0] || "N/A",
            num_facture: facture.invoice_number || "N/A",
            num_pieces: facture.id || "N/A",
            compte_client: facture.client?.account || "N/A",
            nom_client: facture.client?.name || "N/A",
            ice_client: facture.client?.ice || "N/A",
            nom_article: item.product?.name || item.details || "N/A",
            val_pu_ht: prixUnitHT,
            val_qte: qte,
            val_pt_ht: prixHT,
            date_paiement:
              facture.payment && facture.payment.length > 0
                ? facture.payment[facture.payment.length - 1].created_at?.split(
                    "T"
                  )[0] || "N/A"
                : "N/A",
            val_paiement: montantPaye, // Afficher le paiement uniquement sur la première ligne
            mode_paiement: getMoyenPaiement(facture), // Afficher le mode de paiement uniquement sur la première ligne
          });
        });
      }
    });

    // Ajouter une ligne de total avec la nouvelle structure
    donneesFormatees.push({
      date_facture: "",
      date_echeance: "",
      num_facture: "",
      num_pieces: "",
      compte_client: "",
      nom_client: "",
      ice_client: "",
      nom_article: "TOTAL",
      val_pu_ht: "",
      val_qte: totalQte.toFixed(2),
      val_pt_ht: totalPrixHT.toFixed(2),
      date_paiement: "",
      val_paiement: totalPaiement.toFixed(2),
      mode_paiement: "",
    });

    const { value: fileType } = await Swal.fire({
      title: "Choisissez le format de téléchargement",
      input: "radio",
      inputOptions: {
        csv: "CSV",
        pdf: "PDF",
      },
      inputValidator: (value) => {
        if (!value) {
          return "Vous devez choisir une option!";
        }
      },
      showCancelButton: true,
      confirmButtonText: "Télécharger",
      cancelButtonText: "Annuler",
    });

    if (fileType === "csv") {
      const csv = Papa.unparse(donneesFormatees, { delimiter: ";" });
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "etat_factures.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (fileType === "pdf") {
      const { jsPDF } = await import("jspdf");
      const autoTable = (await import("jspdf-autotable")).default;

      const doc = new jsPDF({ orientation: "landscape" });
      const headerHeight = 30;
      const logoWidth = 30;
      const logoHeight = 15;
      const organisationName = organisation?.name || "Nom de l'organisation";
      const tirageDate = `Date de tirage : ${moment().format(
        "DD/MM/YYYY à HH:mm"
      )}`;
      doc.setFontSize(10);
      doc.text(organisationName, 10, 15);
      try {
        const logoX = (doc.internal.pageSize.width - logoWidth) / 2; // Centrer horizontalement
        doc.addImage(logo, "PNG", logoX, 5, logoWidth, logoHeight); // Position : centré, 5 (y)
      } catch (error) {
        console.error("Erreur lors de l'ajout du logo :", error);
      }

      // Ajouter le titre sous le logo
      doc.setFontSize(12);
      doc.text("État de Facturations", doc.internal.pageSize.width / 2, 25, {
        align: "center",
      }); // Centré horizontalement

      // Ajouter la date de tirage à droite
      doc.setFontSize(10);
      const tirageX = doc.internal.pageSize.width - 10; // Aligné à droite
      doc.text(tirageDate, tirageX, 15, { align: "right" });

      // Ajouter une ligne pour séparer l'en-tête
      doc.line(
        10,
        headerHeight,
        doc.internal.pageSize.width - 10,
        headerHeight
      );

      // Définir les colonnes avec les mêmes noms que dans le CSV
      const columns = [
        "Date Facture",
        "Date Échéance",
        "Numéro Facture",
        "N° Pièce",
        "Compte Client",
        "Nom Client",
        "ICE Client",
        "Nom Article",
        "PU HT",
        "Qté",
        "PT HT",
        "Date Paiement",
        "Montant Payé",
        "Mode Paiement",
      ];

      // Transformer les données pour le PDF en utilisant les mêmes champs que le CSV
      const rows = donneesFormatees.map((facture) => [
        facture.date_facture,
        facture.date_echeance,
        facture.num_facture,
        facture.num_pieces,
        facture.compte_client,
        facture.nom_client,
        facture.ice_client,
        facture.nom_article,
        typeof facture.val_pu_ht === "number"
          ? facture.val_pu_ht.toFixed(2)
          : facture.val_pu_ht,
        facture.val_qte,
        typeof facture.val_pt_ht === "number"
          ? facture.val_pt_ht.toFixed(2)
          : facture.val_pt_ht,
        facture.date_paiement,
        typeof facture.val_paiement === "number"
          ? facture.val_paiement.toFixed(2)
          : facture.val_paiement,
        facture.mode_paiement,
      ]);

      // Appliquer des styles spécifiques pour la ligne de total
      const rowStyles = rows.map((_, index) =>
        index === rows.length - 1
          ? { fontStyle: "bold", fillColor: [240, 240, 240] }
          : {}
      );

      // Générer le tableau avec l'en-tête
      autoTable(doc, {
        head: [columns],
        body: rows,
        startY: headerHeight + 10,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [61, 49, 155] }, // Couleur de l'en-tête
        rowStyles: rowStyles, // Appliquer les styles pour chaque ligne
      });

      // Télécharger le PDF
      doc.save("etat_factures.pdf");
    }
  };
  return (
    <>
      <ToastContainer />

      <div className="row" style={{ zIndex: 1 }}>
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header container-fluid row">
              <div className="col-md-9 col-sm-12 card-title">
                {t("Factures d'avoir")}
              </div>
            </div>
            <div className="card-body">
              <div
                class="modal fade"
                id="exampleModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="exampleModalLabel">
                        Changer le status de votre factrue
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Status*</label>
                        <div className="input-group mb-3">
                          <select
                            className="form-select"
                            id="inputGroupSelect01"
                            onChange={handleStatusChange}
                            value={newStatus}
                          >
                            {status.map((s) => (
                              <option
                                value={s.id}
                                selected={s.id === currentSelectedStatus}
                              >
                                {s.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Annuler
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={editInvoiceStatus}
                      >
                        Modifier
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <div style={{ height: 600, width: "100%" }}>
                  <DataGrid
                    rows={invoices}
                    columns={columns}
                    pagination={false}
                    checkboxSelection
                    columnVisibilityModel={
                      visibleColumns ? visibleColumns : columns
                    }
                    onColumnVisibilityModelChange={
                      handleColumnVisibilityModelChange
                    }
                    localeText={
                      i18n.language == "fr"
                        ? frFR.components.MuiDataGrid.defaultProps.localeText
                        : enUS.components.MuiDataGrid.defaultProps.localeText
                    }
                    slotProps={{
                      toolbar: {
                        printOptions: { disableToolbarButton: true },
                        csvOptions: { disableToolbarButton: true },
                      },
                    }}
                    slots={{
                      loadingOverlay: LinearProgress,
                      toolbar: GridToolbar,
                    }}
                    loading={loadingData}
                    onRowSelectionModelChange={(ids) => {
                      console.log("ids", ids);
                      const selectedIDs = new Set(ids);
                      const selectedRowData = invoices.filter((row) =>
                        selectedIDs.has(row.id)
                      );
                      console.log(selectedRowData);
                      setSelectedRow(selectedRowData);
                      let totalAmount = selectedRowData.reduce(
                        (accumulator, inv) => {
                          return accumulator + inv.total_ttc;
                        },
                        0
                      );
                      setGrandTotal(totalAmount);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="card-footer">
              <div className="row">
                <div className="col">
                  <button
                    className="btn btn-primary"
                    onClick={() => downloadEtatFac()}
                  >
                    Telecharger etat de facturation
                  </button>
                </div>
                <div className="col">
                  {grandTotal ? (
                    <div className="d-flex flex-row-reverse">
                      <span
                        className="text-success"
                        style={{
                          fontSize: 19,
                          fontWeight: "bold",
                        }}
                      >
                        {t("Total général")} {Number(grandTotal).toFixed(2)}{" "}
                        {organisation?.currency?.code} TTC
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FactureAvoirList;
